import { useQuery } from '@tanstack/react-query';

import { getWorkspaceUsers } from '../api/magellan/workspaces';
import { useActiveUserQuery } from './useActiveUserQuery.hook';

export function useWorkspaceUsersQuery() {
  const {
    data: { user: activeUser },
  } = useActiveUserQuery();

  const workspaceId = activeUser.activeWorkspace?.id;

  return useQuery({
    queryKey: [getWorkspaceUsers.name, workspaceId],
    queryFn: () => (workspaceId ? getWorkspaceUsers(workspaceId) : []),
    enabled: Boolean(workspaceId),
  });
}
